import React, { useEffect, useState } from "react";
import { InputNumberPadrao, InputPadrao, LabelPadrao, ModalPadrao } from "../../components/Base";
import { BtnGravar, BtnSair } from "../../components/Buttons";
import SelectPesq from "../../components/Selects/SelectPesq";
import { Divider, Select } from "antd";
import { InputNumero } from "../../components/InputNumero";

export default function ModalTransportadora({ visible, onOk, dados, onCancel, isEntrega }) {
  const [dadosInterno, setDadosInterno] = useState({});

  useEffect(() => {
    if (visible) {
      setDadosInterno({
        transportadoraId: dados?.transportadoraId,
        placa: dados?.placa,
        uf: dados?.uf,
        antt: dados?.antt,
        modalidadeFrete: dados?.modalidadeFrete,
        especie: dados?.especie,
        volume: dados?.volume,
        pesoLiq: dados?.pesoLiq,
        pesoBruto: dados?.pesoBruto,
        valorFreteNf: dados?.valorFreteNf,
      });
    }

  }, [visible]);

  return <ModalPadrao title="Dados do transporte" style={{ minHeight: 400 }} width={800} visible={visible} onCancel={onCancel} footer={<>
    <BtnGravar onClick={() => onOk(dadosInterno)} />
    <BtnSair onClick={onCancel} />
  </ >}>
    <SelectPesq title="Transportadora" modelo="transportadora" value={dadosInterno?.transportadoraId} onChange={v => setDadosInterno({ ...dadosInterno, transportadoraId: v })} placeholder="Pesquisar transportaddora" maxTagTextLength={30} noMargin tabIndex={100} showAdd showEdit />

    <Divider orientation="left">Veículo</Divider>
    <div style={{ display: "flex" }}>
      <div style={{ width: "45%" }}>
        <LabelPadrao noMargin>Placa</LabelPadrao>
        <InputPadrao value={dados?.placaVeiculo || dadosInterno?.placa} onChange={v => setDadosInterno({ ...dadosInterno, placa: v.target.value })} placeholder="Informe a placa" tabIndex={101} disabled={dados?.veiculoId?.length} />
      </div>
      <div style={{ width: "45%", margin: "0 10px" }}>
        <LabelPadrao noMargin>ANTT</LabelPadrao>
        <InputPadrao value={dadosInterno?.antt} onChange={v => setDadosInterno({ ...dadosInterno, antt: v.target.value })} placeholder="Informe a ANTT" tabIndex={102} disabled={dados?.veiculoId?.length} />
      </div>

      <div style={{ width: "10%" }}>
        <LabelPadrao noMargin>UF</LabelPadrao>
        <InputPadrao value={dados?.ufVeiculo || dadosInterno?.uf} onChange={v => setDadosInterno({ ...dadosInterno, uf: v.target.value })} placeholder="UF" maxLength={2} tabIndex={103} disabled={dados?.veiculoId?.length} />
      </div>
    </div>

    <Divider orientation="left">Dados/Volume</Divider>
    <div style={{ display: "flex" }}>
      <div style={{ width: "70%", marginRight: 10 }}>
        <LabelPadrao noMargin>Modalidade de frete</LabelPadrao>
        <Select style={{ width: "100%" }} value={dadosInterno?.modalidadeFrete} onChange={v => setDadosInterno({ ...dadosInterno, modalidadeFrete: v })} placeholder="Informe a modalidade de frete" showSearch allowClear>
          <Select.Option value="0">0 - Contratação do Frete por conta do Remetente (CIF)</Select.Option>
          <Select.Option value="1">1 - Contratação do Frete por conta do Destinatário (FOB)</Select.Option>
          <Select.Option value="2">2 - Contratação do Frete por conta de Terceiros</Select.Option>
          <Select.Option value="3">3 - Transporte Próprio por conta do Remetente</Select.Option>
          <Select.Option value="4">4 - Transporte Próprio por conta do Destinatário</Select.Option>
          <Select.Option value="9">9 - Sem Ocorrência de Transporte</Select.Option>
        </Select>
      </div>

      <div style={{ width: "30%" }}>
        <LabelPadrao noMargin>Espécie</LabelPadrao>
        <InputPadrao value={dadosInterno?.especie} onChange={v => setDadosInterno({ ...dadosInterno, especie: v.target.value })} placeholder="Informe a espécie" tabIndex={105} />
      </div>
    </div>

    <div style={{ display: "flex" }}>
      <div style={{ width: "25%" }}>
        <LabelPadrao>Volume</LabelPadrao>
        <InputNumberPadrao style={{ width: "100%" }} value={dadosInterno?.volume} onChange={v => setDadosInterno({ ...dadosInterno, volume: v })} placeholder="Informe o volume" precision={2} tabIndex={106} nullable min={0} />
      </div>

      <div style={{ width: "25%", margin: "0 10px" }}>
        <LabelPadrao>Peso líquido</LabelPadrao>
        <InputNumberPadrao style={{ width: "100%" }} value={dadosInterno?.pesoLiq} onChange={v => setDadosInterno({ ...dadosInterno, pesoLiq: v })} placeholder="Informe o peso líquido" precision={2} tabIndex={107} nullable min={0} />
      </div>

      <div style={{ width: "25%" }}>
        <LabelPadrao>Peso bruto</LabelPadrao>
        <InputNumberPadrao style={{ width: "100%" }} value={dadosInterno?.pesoBruto} onChange={v => setDadosInterno({ ...dadosInterno, pesoBruto: v })} placeholder="Informe o peso bruto" precision={2} tabIndex={108} nullable min={0} />
      </div>

      <div style={{ width: "25%", marginLeft: 10 }}>
        <LabelPadrao>Valor frete</LabelPadrao>
        <InputNumero style={{ width: "100%" }} value={dadosInterno?.valorFreteNf} onChange={v => setDadosInterno({ ...dadosInterno, valorFreteNf: v })} placeholder="Informe o valor do frete" tabIndex={109} nullable min={0} disabled={isEntrega} />
      </div>
    </div>

  </ModalPadrao>;
}

